import { GetValidateSurveyTokenResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetValidateSurveyTokenResponse } from '@/types/Psychosocial';

export class GetValidateSurveyTokenMapper {
	constructor(private readonly data: GetValidateSurveyTokenResponseDTO) {}

	toDomain(): GetValidateSurveyTokenResponse {
		return {
			survey_link_id: this.data.survey_link_id,
			anonymous: this.data.anonymous,
			survey_id: this.data.survey_id,
			employee_code: this.data.employee_code,
			expired: this.data.expired,
			expires_at: this.data.expires_at
		};
	}
}
